export enum PlanRewardPriority {
    HIGH = 'high',
    MEDIUM = 'medium',
    LOW = 'low',
}
